import { injectBrandFonts, type BrandFontFace } from '../../shared/font-injector';
import { MACRO_MEDIA_BASE } from '../_shared/data/media';

const FONT_BASE_URL = `${MACRO_MEDIA_BASE}/fonts`;

const FONTS: BrandFontFace[] = [
  { family: 'DM Sans', weight: 300, style: 'normal', file: 'DMSans-Light.ttf', format: 'truetype' },
  { family: 'DM Sans', weight: 400, style: 'normal', file: 'DMSans-Regular.ttf', format: 'truetype' },
  { family: 'DM Sans', weight: 500, style: 'normal', file: 'DMSans-Medium.ttf', format: 'truetype' },
  { family: 'DM Sans', weight: 600, style: 'normal', file: 'DMSans-SemiBold.ttf', format: 'truetype' },
  { family: 'DM Sans', weight: 700, style: 'normal', file: 'DMSans-Bold.ttf', format: 'truetype' },
  { family: 'DM Sans', weight: 800, style: 'normal', file: 'DMSans-ExtraBold.ttf', format: 'truetype' },
  { family: 'DM Sans', weight: 900, style: 'normal', file: 'DMSans-Black.ttf', format: 'truetype' }
];

export function injectMacroFonts() {
  injectBrandFonts({ styleId: 'macro-fonts', baseUrl: FONT_BASE_URL, fonts: FONTS });
}
